import React from "react";
import { CGE } from "../../../../common/components/CGE";
import Loading from "../../../../common/components/Loading";
import { decode_utf8, formatDate } from "../../../../common/utils/utilsFunc";
import { optionsMonth,optionsYear } from "../../../../common/utils/globalVars";
import StockReportContextProvider, { StockReportContext, ACTIONS }  from '../../context/StockReportContextProvider';
import Chart from 'react-apexcharts';
import GenericReportTable from '../../../reports/GenericReportTable'

const ReportController = ({ props }) => {
    const [state, dispatch] = React.useContext(StockReportContext);
    const [loading, setLoading] = React.useState(false);
    const [currentDataChart, setCurrentDataChart] = React.useState([]);
    const [currentInfoChart, setCurrentInfoChart] = React.useState([]);
    const [filterChart, setFilterChart] = React.useState("M");
    const [filterAction, setFilterAction] = React.useState(0);
    const [optionsAction, setOptionsAction] = React.useState([]);
    const [inputYear, setInputYear] = React.useState("");
    const [inputMonth, setInputMonth] = React.useState("");
    const [inputDate, setInputDate] = React.useState("");
    const [verifInputs, setVerifInputs] = React.useState({});
    const [actionReports, setActionReports] = React.useState(null);
    const [newArrTitle, setNewArrTitle] = React.useState([]);
    const [arline1Table, setArline1Table] = React.useState([]);
    const [arline2Table, setArline2Table] = React.useState([]);
    const [currentArray, setCurrentArray] = React.useState([]);
    const flagSection = true;
    React.useEffect(() => {
        setNewArrTitle([" ",...newArrTitle]);

        const arTot = arline1Table.map(function (num, idx) {
            return num + arline2Table[idx];
        });

        setCurrentArray([[props?.name_company_1_page_stock_report,...arline1Table],[props?.name_company_2_page_stock_report,...arline2Table],["TOTAL",...arTot]])

    },[currentInfoChart])
    
    React.useEffect(() => {
        if(state?.actionList) {
            let auxOptionsAction = [{label:"Todas",value:0}];
            state?.actionList.items.forEach((obj) => {
                auxOptionsAction.push({ label: obj.nomAccion, value: obj.id });
            });
            setOptionsAction(auxOptionsAction)
        }
    },[state?.actionList])

    const config = {
            
        series: [
            {
                name: decode_utf8(props?.name_company_1_page_stock_report),
                data: currentDataChart.length === 2?currentDataChart[0]:[]
            },
            {
                name: decode_utf8(props?.name_company_2_page_stock_report),
                data: currentDataChart.length === 2?currentDataChart[1]:[]
            }
        ],
        options: {
            chart: {
                zoom: {
                    enabled: true
                },
                height: 300,
                type: 'bar',
                dropShadow: {
                    enabled: true,
                    color: '#000',
                    top: 18,
                    left: 7,
                    blur: 10,
                    opacity: 0.2
                },
                toolbar: {
                    show: true
                }
            },
            colors: ['#A5CE40', '#E79E38'],
            dataLabels: {
                enabled: false,
            },
            stroke: {
                curve: 'smooth' //'smooth'
            },
            title: {
                text: currentInfoChart?.titleChart,
                align: 'left'
            },
            grid: {
                borderColor: '#e7e7e7',
                row: {
                    colors: ['#f3f3f3', 'transparent'],
                    opacity: 0.5
                },
            },
            markers: {
                size: 3
            },
            xaxis: {
                categories: currentInfoChart?.categories,
                title: {
                    text: currentInfoChart?.nameX,
                },
                labels: {
                    show: true,
                    formatter: function (val) {
                        let months = [
                            'Enero',
                            'Febrero',
                            'Marzo',
                            'Abril',
                            'Mayo',
                            'Junio',
                            'Julio',
                            'Agosto',
                            'Septiembre',
                            'Octubre',
                            'Noviembre',
                            'Diciembre',
                        ];
                        if (Number(val) >= 0) {
                            return months[val - 1];
                        } else {
                            return val;
                        }
                    },
                },
            },
            yaxis: {
                title: {
                    text: decode_utf8(props?.subtitle_y_chart_page_stock_report)
                },
                min: currentInfoChart?.min,
                max: currentInfoChart?.max
            },
            legend: {
                position: 'top',
                horizontalAlign: 'right',
                floating: true
            }
        }
    };

    const options = [
        {
          label: "Seleccione",
          value: "",
        },
        {
          label: "Diario",
          value: "D",
        },
        {
          label: "Mensual",
          value: "M",
        },
        {
          label: "Hora",
          value: "H",
        }
    ];

    function sendFilterChart() {
        if(filterChart === "") {
            props.setGlobalAlert("Complete todos los campos obligatorios.", "warning");
            setVerifInputs({...verifInputs, filterChart: true});
        } else {
            setCurrentDataChart([]);
            setVerifInputs({});
            
            switch(filterChart){
                case 'M':
                    if(!inputYear || !inputMonth) {
                        props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
                        let auxVerif = {}
                        if(!inputYear) {
                            auxVerif.year = true;
                        } else {
                            auxVerif.year = false;
                        }
                        if(!inputMonth) {
                            auxVerif.month = true;
                        } else {
                            auxVerif.month = false;
                        }
                        setVerifInputs(auxVerif);
                        return false;
                    }
                break;
                case 'D':
                    if(!inputYear) {
                        props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
                        setVerifInputs({...verifInputs,year:true});
                        return false;
                    } else {   
                        setVerifInputs({...verifInputs,year:false});
                    }
                break;
                case 'H':
                    if(!inputDate) {
                        props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
                        setVerifInputs({...verifInputs,date:true});
                        return false;
                    } else {
                        setVerifInputs({...verifInputs,date:false});
                    }
                break;
                default:
                    setCurrentDataChart([]);
                    return false;
                break;
            }

            setActionReports({
                ano: inputYear,
                mes: inputMonth,
                tipo: filterChart,
                idAccion: filterAction
            });
        }
    };

    function shouldHideData(dataArray) {
        const auxArray = dataArray.map(innerDataArray => {
            if(innerDataArray.find(el => el !== 0)) {
                return true;
            } else {
                return false;
            }
        });

        if(auxArray.find(el => el === true)) {
            return false;
        } else {
            return true;
        }
    }

    React.useEffect(() => {
        setVerifInputs({});
        setCurrentDataChart([]);
        setInputYear("");
        setInputMonth("");
        setInputDate("");
    },[filterChart])

    React.useEffect(() => {
        if(actionReports) {
            setLoading(true);
            dispatch({
                type: ACTIONS.SET_ACTION_REPORTS,
                payload: actionReports
            });
        }
    }, [actionReports]);

    function handleChartData(y0, y1, axisX, title, nameAxisX) {
        if (filterChart === 'D') {
            let monthsChart = monthMapping(axisX);
            setNewArrTitle(monthsChart);
        } else {
            setNewArrTitle(axisX);
        }
        setArline1Table(y0);
        setArline2Table(y1);
        setCurrentInfoChart({
            titleChart: decode_utf8(title),
            categories: axisX,
            nameX: nameAxisX,
            maxRange: 140000,
            minRange: 0
        });
        setCurrentDataChart([y0, y1]);
    }
    function monthMapping(axisX){
        let monthsChart = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre',
            'Diciembre']
        let mappedMonths = [];

        axisX.forEach(axisXElement => {
            mappedMonths.push(monthsChart[axisXElement - 1])
        });

        return mappedMonths;
    }

    React.useEffect(() => {
        if(state.actionReportsResponse) {
            switch(filterChart) {
                case 'M':
                    handleChartData(
                        [state.actionReportsResponse.totalCge],
                        [state.actionReportsResponse.totalEdelmag],
                        ["TOTAL"],
                        props?.title_chart_day_page_stock_report,
                        inputMonth+"/"+inputYear
                    );
                    setLoading(false);
                break;
                // case 'D':
                //     handleChartData(
                //         state.actionReportsResponse.empresas[0]?.acciones.map(el => el.quantity),
                //         state.actionReportsResponse.empresas[1]?.acciones.map(el => el.quantity),
                //         state.actionReportsResponse.empresas[0]?.acciones.map(el => el.month),
                //         props?.title_chart_month_page_stock_report,
                //         inputYear
                //     );
                //     setLoading(false);
                // break;
                // case 'H':
                //     handleChartData(
                //         state.actionReportsResponse.empresas[0]?.acciones.map(el => el.quantity),
                //         state.actionReportsResponse.empresas[1]?.acciones.map(el => el.quantity),
                //         state.actionReportsResponse.empresas[0]?.acciones.map(el => el.hour.slice(0, -3)),
                //         props?.title_chart_hour_page_stock_report,
                //         inputDate
                //     );
                //     setLoading(false);
                // break;
                default:
                    setLoading(false);
                break;
            }
        }
    }, [state.actionReportsResponse]);


    React.useEffect(() => {
        if(currentDataChart.length > 0 && shouldHideData(currentDataChart) && !loading) {
            props.setGlobalAlert("No se encontraron registros.", "warning");
        }
    }, [currentDataChart]);
    
    return (
        <>
            <CGE.Panel title={decode_utf8(props?.title_page_stock_report)}>
                <CGE.PanelSection title={"1. " + decode_utf8(props?.subtitle_filter_page_stock_report)}>
                <CGE.Spacing type="mg" />
                    <CGE.PanelContainer
                        alingItensCenter={true}
                        size="md"
                    >
                        {/* <CGE.FormsField
                            handleChange={(e) => setFilterChart(e.target.value)}
                            horizontal={true}
                            idFormElement="filterChart"
                            labelName="Tipo de agrupación:"
                            listOptions={options}
                            mandatoryElement={true}
                            style={{ background: '#fff' }}
                            typeElement="select"
                            typeFormElement="text"
                            hasError={verifInputs?.filterChart}
                            msgError="Debes seleccionar un tipo de agrupación"
                        /> */}

                        <CGE.FormsField
                            handleChange={(e) => setFilterAction(e.target.value)}
                            horizontal={true}
                            idFormElement="filterAction"
                            labelName="Acciones:"
                            listOptions={optionsAction}
                            mandatoryElement={true}
                            style={{ background: '#fff' }}
                            typeElement="select"
                            typeFormElement="text"
                        />

                        {(filterChart === "D" || filterChart === "M")  &&
                            <CGE.FormsField
                                handleChange={(e) => setInputYear(e.target.value)}
                                horizontal={true}
                                idFormElement="filterYear"
                                labelName="Año:"
                                listOptions={optionsYear(props?.number_years_select_page_stock_report?props?.number_years_select_page_stock_report:1)}
                                mandatoryElement={true}
                                style={{ background: '#fff' }}
                                typeElement="select"
                                typeFormElement="text"
                                hasError={verifInputs?.year}
                                msgError="Debes seleccionar un año"
                                value={inputYear}
                            />
                        }
                        {filterChart === "M"  &&
                            <CGE.FormsField
                                handleChange={(e) => setInputMonth(e.target.value)}
                                horizontal={true}
                                idFormElement="filterMonth"
                                labelName="Mes:"
                                listOptions={optionsMonth}
                                mandatoryElement={true}
                                style={{ background: '#fff' }}
                                typeElement="select"
                                typeFormElement="text"
                                hasError={verifInputs?.month}
                                msgError="Debes seleccionar un mes"
                                value={inputMonth}
                            />
                        }
                        {filterChart === "H"  &&
                            <CGE.FormsField
                                handleChange={(e) => {
                                    setInputDate(e.target.value);
                                    let fechaVal = e.target.value;
                                    if(fechaVal) {
                                        fechaVal = new Date(fechaVal);
                                        setInputMonth(fechaVal.getMonth() + 1);
                                        setInputYear(fechaVal.getFullYear());
                                    }
                                }}
                                horizontal={true}
                                idFormElement="filterDate"
                                mandatoryElement={true}
                                typeElement="input"
                                typeFormElement="date"
                                labelName="Fecha:"
                                placeholder="Fecha"
                                hasError={verifInputs?.date}
                                msgError="Debes seleccionar la fecha"
                                value={inputDate}
                            />
                        }
                            
                    </CGE.PanelContainer>
                    <div className='col-md-12 pt-2 d-flex justify-content-end'>
                        <CGE.Button
                            size="sm"
                            label="Filtrar"
                            onClick={() => {sendFilterChart()}}
                        />
                    </div>
                </CGE.PanelSection>                
                {currentDataChart.length > 0 && !shouldHideData(currentDataChart) && !loading &&
                    <CGE.PanelSection title={"2. " + decode_utf8(props?.subtitle_chart_page_stock_report)}>
                        <Chart options={config.options} series={config.series} type="bar" height={350} />
                        {currentArray?.length > 0 && !loading &&
                            <GenericReportTable props={{...props, currentArray, newArrTitle, customTitle: "3. Tabla"}}/>
                        }
                    </CGE.PanelSection>
                }
                
            </CGE.Panel>
            {loading && <Loading />}
        </>
    );
};

const StockReportControllerWithProvider = ({ props }) => (
    <StockReportContextProvider>
        <ReportController props={props} />
    </StockReportContextProvider>
);

export default StockReportControllerWithProvider;
